<script lang="ts">
	import Form from "./Form.svelte";

	export let saveFields: (form: HTMLFormElement) => boolean | Promise<boolean>;
	export let submit: (form: HTMLFormElement) => unknown;
	export let form: HTMLFormElement | null = null;
	let formClass: string | undefined = undefined;
	export { formClass as class };

	let isSaved = true;

	async function onChange(): Promise<void> {
		if (!form) {
			throw new Error("Form element not found");
		}

		isSaved = await saveFields(form);
	}

	async function onSubmit(event: Event): Promise<void> {
		await submit(event.target as HTMLFormElement);
	}

	export function preventQuittingUnsavedForm(event: BeforeUnloadEvent, isSaved: boolean): void {
		if (!isSaved) {
			event.preventDefault();
		}
	}

	function beforeUnload(event: BeforeUnloadEvent): void {
		preventQuittingUnsavedForm(event, isSaved);
	}
</script>

<svelte:window on:beforeunload={beforeUnload} />

<Form bind:form on:change={onChange} on:change on:submit={onSubmit} class={formClass}>
	<slot />
</Form>
